/**
 * AR Quick Look detection + helpers for iOS. iOS Safari does not support WebXR
 * immersive-ar; instead it exposes AR Quick Look via <a rel="ar"> links to USDZ.
 */
export function isQuickLookSupported(): boolean {
  if (typeof document === 'undefined') return false;
  const a = document.createElement('a');
  return a.relList && typeof a.relList.supports === 'function' && a.relList.supports('ar');
}

/**
 * Programmatically open a USDZ in AR Quick Look by synthesizing an <a rel="ar">
 * click. Returns true if triggered, false if unsupported.
 */
export function openQuickLook(usdzUrl: string): boolean {
  if (!isQuickLookSupported()) return false;
  const a = document.createElement('a');
  a.setAttribute('rel', 'ar');
  a.setAttribute('href', usdzUrl);
  a.style.display = 'none';
  // Apple requires a user gesture; this must be called from a click handler.
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  return true;
}
